import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

// Trade project - HTTPS configuration (same pattern as Mehfil)
export default new Echo({
  broadcaster: "reverb",
  key: "a2bdd6150b11503a07f2bdfa850722d7", // REVERB_APP_KEY
  wsHost: "api.vastrosa.aaibuzz.com",       // WebSocket host
  wsPort: 443,                               // HTTPS port (via Nginx proxy)
  wssPort: 443,
  forceTLS: true,                            // HTTPS = true
  enabledTransports: ["wss"],                // Only wss for HTTPS
  disableStats: true,
  authEndpoint: "https://api.vastrosa.aaibuzz.com/api/broadcasting/auth",
  auth: {
    headers: {
      // Dynamically get token on each auth request (same as Mehfil)
      get Authorization() {
        const token = localStorage.getItem("token");
        return token ? `Bearer ${token}` : '';
      },
      Accept: "application/json",
    },
  },
});
